import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';
import { TreeTable } from 'primeng/treetable';
import { LanguageService } from 'src/app/_services/language.service';

@Component({
  selector: 'app-cliente-edit',
  standalone: false,

  templateUrl: './cliente-edit.component.html',
  styleUrl: './cliente-edit.component.scss',
  providers: [MessageService],
})
export class ClienteEditComponent implements OnInit {
  expandedRows = {};

  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  tabsFields:any[]=[];
  columnsOppourtunities:any[]=[];
  opportunitiesData:any[]=[];
  pageTitle:string="Nuovo cliente";
  backUrl:string='/accounts';
  action:any='';
  loading:boolean = true;
  isLoaded: Promise<boolean> | undefined;
  
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public lang :LanguageService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    
    let modulefields=this.globalService.configModules.filter((m)=>m.name=='accounts');
    this.tabsFields=modulefields[0].tabsFields;
    this.tabsFields.forEach((e:any)=>{
      if(e.fields){
        e.fields.forEach((f:any)=>{
          if(f.fieldGroup){
            f.fieldGroup.forEach((g:any)=>{
              if((g.props.options)&&(typeof g.props.options == 'string')) {
                g.props.options=this.apiService.postobs(g.props.options,{});
                g.props['valueProp']='value';
                g.props['labelProp']='label';
              }
            });
          }
        });
      }
    });
            
    this.action=this.route.snapshot.paramMap.get('action');
    let user_id=this.globalService.getUser().id;
    if(this.route.snapshot.paramMap.get('id')){
      this.pageTitle="Modifica cliente";
      this.apiService.post('app/accounts_listall',{logged_user_id:user_id,id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.model = data2.Result[0];
        this.apiService.post('app/opportunities_listall',{logged_user_id:user_id,account_id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
          this.opportunitiesData = data2.Result;
          this.isLoaded = Promise.resolve(true); 
        });
      });    
    }
  }

  save(){
    this.model['logged_user_id']=this.globalService.getUser().id;
    this.apiService.post('app/account_update',this.model).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      setTimeout(() => {
         this.router.navigateByUrl(this.backUrl);   
      }, 1500);
    });
  }
  
  nuovoPreventivo(){
     this.router.navigateByUrl('opportunities/opportunity-edit/new/'+this.model.id);
  }

    annulla(){
      this.router.navigateByUrl(this.backUrl);
    }

    addSingle(sev: string, sum: string, det: string) {
      this.messageService.add({severity: sev, summary: sum, detail: det});
    }

  /*
  
  clearEditState() {
    this.nodeToReplace = undefined;
    this.nodeToEdit = undefined;
    this.parentToAddTo = undefined;
  }

  hideDialog() {
    this.clearEditState();
    this.editDialog = false;
  }

  saveRow() {
    if (this.nodeToReplace) {
      if (this.parentToAddTo) {
        const index = this.parentToAddTo!.children!.indexOf(this.nodeToReplace);
        this.parentToAddTo!.children![index] = this.nodeToEdit!;
      } else {
        const index = this.preventiviList.indexOf(this.nodeToReplace);
        this.preventiviList[index] = this.nodeToEdit!;
      }
      this.selectedNodes.push(this.nodeToEdit!);
      this.selectedNodes = this.selectedNodes.filter(
        (node) => node != this.nodeToReplace
      );
      this.preventiviList = [...this.preventiviList];
    } else {
      if (this.parentToAddTo) {
        if (this.parentToAddTo.children)
          this.parentToAddTo.children = [
            this.nodeToEdit!,
            ...this.parentToAddTo.children,
          ];
        else this.parentToAddTo.children = [this.nodeToEdit!];

        this.parentToAddTo.expanded = true;
        this.preventiviList = [...this.preventiviList];
      } else {
        this.preventiviList = [this.nodeToEdit!, ...this.preventiviList];
      }
    }
    this.clearEditState();
    this.editDialog = false;
  }
*/

  expandAll() {
      this.expandedRows = this.opportunitiesData.reduce((acc, p) => (acc[p.id] = true) && acc, {});
  }

  collapseAll() {
      this.expandedRows = {};
  }

  onRowExpand(event: TableRowExpandEvent) {
     
  }

  onRowCollapse(event: TableRowCollapseEvent) {
    
  }

  getSeverityOpp(status: string) {
      switch (status) {
          case 'INSTOCK':
              return 'success';
          case 'LOWSTOCK':
              return 'warning';
          case 'OUTOFSTOCK':
              return 'danger';
      }
      return 'success';
  }

  getSeverityCella(status: string) {
      switch (status) {
          case 'CONFERMATA':
              return 'success';
          case 'IN PROGETTAZIONE':
              return 'warning';
      }
      return 'info';
  }
   
  editPrev(record:any){
    this.router.navigateByUrl('opportunities/opportunity-edit/update/'+record.id);
  }
}
